import axios from "axios";

const api = axios.create({
   baseURL: "https://api-webservices-bibliotecas.dpeam.com"
})

export default api;
